var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Fragment, Component } from 'react';
import ListItem from './ListItem';
import Translate from '../Translate';

var List = function (_Component) {
  _inherits(List, _Component);

  function List() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, List);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = List.__proto__ || Object.getPrototypeOf(List)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      showDetail: false
    }, _this.toggleDetail = function (id) {
      _this.setState({
        showDetail: id
      });

      if (id === _this.state.showDetail) {
        _this.setState({
          showDetail: false
        });
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(List, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      return React.createElement(
        Fragment,
        null,
        this.props.data.length === 0 ? React.createElement(
          Fragment,
          null,
          this.props.noData ? React.createElement(
            'div',
            { className: 'no-list-message' },
            React.createElement(Translate, { id: this.props.noData, defaultMessage: 'No data' })
          ) : React.createElement(
            'div',
            { className: 'no-list-data' },
            React.createElement(Translate, { id: 'list.no_data', defaultMessage: 'No data' })
          )
        ) : React.createElement(
          'div',
          { className: 'tg-list' },
          this.props.data.map(function (item) {
            return React.createElement(ListItem, {
              id: item.id,
              info: item.info,
              detail: item.detail,
              showDetail: _this2.state.showDetail === item.id,
              onClick: _this2.toggleDetail
            });
          })
        )
      );
    }
  }]);

  return List;
}(Component);

export default List;